import { useEffect, useState } from 'react';
import { getGameEventById } from 'services';

import { GameEvent } from '../../../../../../../types/components/GameEvent';

export type useGameEventParams = {
  gameEventId: string;
};

const useGameEvent = ({
  gameEventId,
}: useGameEventParams): { gameEvent: GameEvent | null; isLoading: boolean } => {
  const [gameEvent, setGameEvent] = useState<GameEvent | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      setGameEvent(null);
      if (gameEventId) {
        setLoading(true);

        const gameEvent = await getGameEventById(gameEventId);
        if (gameEvent) {
          setGameEvent(gameEvent);
        }
      }

      setLoading(false);
    })();
  }, [gameEventId]);

  return {
    isLoading,
    gameEvent,
  };
};

export default useGameEvent;
